import { AddUsersWizard } from "@/features/people/components/add-users-wizard";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";

interface Props {
  workspaceId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onImported?: () => void;
}

export function AddUsersDialog({ workspaceId, open, onOpenChange, onImported }: Props) {
  function handleOpenChange(next: boolean) {
    onOpenChange(next);
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="flex max-h-[min(720px,90vh)] w-[min(720px,95vw)] max-w-none flex-col gap-0 p-0 sm:max-w-none">
        {open ? (
          <AddUsersWizard
            workspaceId={workspaceId}
            onClose={() => handleOpenChange(false)}
            onImported={onImported}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
